import { CellCustomDataType, ColumnType } from "..";
import { DataType, DataRowType } from "../types";
import { CellWrapper } from "./TableCellWrapper";
import { useTableContext } from "./TableContext";
import { calculateWidth } from "./util";

// Data cell 
export const DataCell = ({ data, column: { Cell, ...column } }: DataType) => {
    const { spacing, verticalAlignTd } = useTableContext();
    const { width, ID } = column;

    const style: React.CSSProperties = {
        ...column.style,
        width: calculateWidth(width, spacing ?? "default"),
        ...(column?.whiteSpace === 'nowrap' ? { whiteSpace: 'nowrap' } : {})
    }

    let Cdata = data[column.accessor];

    const p: CellCustomDataType = {
        ...column,
        origin: data,
        value: Cdata
    };

    if (Cell && typeof Cell === 'function') {
        Cdata = Cell(p);
    }

    const htmlAttributes: React.HTMLAttributes<HTMLElement> = {
        className: `--cell-valign-${verticalAlignTd ?? 'top'}`,
        id: ID ? ID(p) : undefined // ID can be passed through column config which will define the column ID
    }

    /**
     * By default colum with is content width, if custom column width present then we added one wrapper div inside the cell to adjust the width, 
     * directly applying width to td, th not worked, to solve the issue we used this wrapper
     */
    if (column.width) {
        return <td {...htmlAttributes}><CellWrapper style={style}>{Cdata}</CellWrapper></td>;
    }

    return <td {...htmlAttributes} style={style}>{Cdata}</td>;
}

export const DataRow = ({ data }: DataRowType) => {
    const { columns } = useTableContext();
    return <tr>
        {columns.map((column: ColumnType, index: number) => {
            return <DataCell key={index} column={column} data={data} />;
        })}
    </tr>
}
